/* Rowgins faithful checkout — re-wires the frozen snapshot + VoltGuard-style trim.
   Keeps: bundles (no "Step 1:" / no icon), qty steppers, Order Summary (product + total).
   Removes: shipping protection, shipping line, tree-kindness donation, Step 2 payment block + secure-methods block.
   Adds: green "Add to cart" (VoltGuard), SECURE PAYMENT GUARANTEED icons (no Klarna), 90-day guarantee.
   Footer -> PrimeGradeLabs. Checkout -> Shopify. */
(function(){
  "use strict";

  var CONFIG = window.MBA_CONFIG || {};
  var SHOPIFY_STORE = CONFIG.store || window.location.origin;
  var VARIANT = CONFIG.variants || {
    "Blue":       "67649334739129",
    "Brown":      "67649334771897",
    "2 x Blue":   "67649334804665",
    "2 x Brown":  "67649334837433",
    "Blue+Brown": "67649334870201"
  };
  var ASSET = CONFIG.assets || {};

  var money = function(n){ return "$" + (Math.round(n*100)/100).toFixed(2); };
  var parseMoney = function(t){ return parseFloat((t||"").replace(/[^0-9.]/g,"")) || 0; };
  var ready = function(fn){ if(document.readyState!=="loading") fn(); else document.addEventListener("DOMContentLoaded",fn); };
  var tightText = function(s){ var re=new RegExp(s,"i"), best=null; [].slice.call(document.querySelectorAll("*")).forEach(function(e){ if(re.test(e.textContent||"") && (!best || (e.textContent||"").length < (best.textContent||"").length)) best=e; }); return best; };

  ready(function(){ try{ run(); }catch(e){ console.error("wire error", e); } });

  var bundles, sel=0;

  function run(){
    injectCss();

    // ---------- parse bundles ----------
    bundles = [].slice.call(document.querySelectorAll(".product-item")).map(function(it){
      var card = it.querySelector(".product-item-v8") || it.firstElementChild;
      return {
        it:it, card:card,
        name: txt(it.querySelector(".product-row-variant-v8")),
        sales: parseMoney(txt(it.querySelector(".product-row-sales-price-v8"))),
        market: parseMoney(marketText(it.querySelector(".product-row-market-price-v8"))),
        qtyInput: it.querySelector(".product-row-quantity-input-v8"),
        box: it.querySelector(".product-row-quantity-box-v8"),
        radioOuter: it.querySelector(".product-row-checkbox-v8 > div"),
        img: it.querySelector(".product-row-img-v8 img"),
        qty: 1
      };
    }).filter(function(b){ return b.name && b.card; });
    bundles.forEach(function(b){ var s=b.box?[].slice.call(b.box.children).filter(function(c){return c.tagName==="DIV";}):[]; b.minus=s[0]; b.plus=s[1]; var v=parseInt(b.qtyInput&&b.qtyInput.value,10); b.qty=(v>0?v:1); });
    if(!bundles.length) return;

    // The captured page visually defaults to the Best Seller Blue+Brown bundle.
    // Keep the live checkout state aligned with that visual default before the
    // shopper interacts with any card.
    var defaultIndex = bundles.findIndex(function(b){ return b.name === "Blue+Brown"; });
    sel = defaultIndex >= 0 ? defaultIndex : 0;

    // ---------- trim + inject ----------
    trimPage();

    // ---------- bundle selection + qty ----------
    bundles.forEach(function(b,i){
      b.card.addEventListener("click", function(e){
        if(b.minus && b.minus.contains(e.target)){ b.qty=Math.max(1,b.qty-1); sync(b); pick(i); e.stopPropagation(); return; }
        if(b.plus && b.plus.contains(e.target)){ b.qty=Math.min(99,b.qty+1); sync(b); pick(i); e.stopPropagation(); return; }
        pick(i);
      });
      if(b.qtyInput) b.qtyInput.addEventListener("input", function(){ var v=parseInt(b.qtyInput.value,10); b.qty=(v>0?v:1); pick(i); });
    });

    // ---------- order summary collapse + hide shipping section ----------
    var summaryRoot = document.querySelector(".order-summary") || document;
    var shipRow = summaryRoot.querySelector(".summary-shipping-row");
    if(shipRow && shipRow.parentElement) shipRow.parentElement.style.display="none"; // hides shipping + protection block
    [].slice.call(summaryRoot.querySelectorAll(".total-savings")).forEach(function(block){ block.remove(); });
    removeRowsByLabel(summaryRoot, "Total savings");
    var productList = summaryRoot.querySelector(".productList");
    var sumBody = productList ? productList.closest('[class*="grid-rows-"]') : null;
    var hl = [].slice.call(summaryRoot.querySelectorAll("*")).find(function(e){return e.children.length===0 && e.textContent.trim()==="Order Summary";});
    var sumHeader = hl ? (hl.closest('[class*="cursor-pointer"]') || hl.closest("div.flex.items-center.justify-between")) : null;
    if(sumHeader && sumBody) collapsible(sumHeader, sumBody);
    window.__sumRoot = summaryRoot; window.__sumHeader = sumHeader;

    // init
    bundles.forEach(function(b,i){ styleCard(b, i===sel); sync(b); });
    render();

    renameHeading();
    swapFooter();
  }

  function pick(i){ sel=i; bundles.forEach(function(b,idx){ styleCard(b, idx===sel); }); render(); }
  function sync(b){ if(b.qtyInput) b.qtyInput.value=b.qty; }

  function styleCard(b, active){
    var c=b.card;
    c.setAttribute("data-pg-selected", active ? "true" : "false");
    if(active){ c.style.border="3px solid #7CA4FF"; c.style.background="#F3F9FF"; c.style.padding="12px"; }
    else { c.style.border="1px solid rgba(224,224,224,.8)"; c.style.background="#fff"; c.style.padding="14px"; }
    if(b.radioOuter){
      // The captured default card includes its own inner dot. Remove that frozen
      // marker so the live selection state is controlled only by this script.
      [].slice.call(b.radioOuter.children).forEach(function(child){
        if(!child.classList.contains("pg-dot")) child.remove();
      });
      if(active){ b.radioOuter.style.borderColor="#7CA4FF"; if(!b.radioOuter.querySelector(".pg-dot")){ var d=document.createElement("div"); d.className="pg-dot"; d.style.cssText="width:8px;height:8px;border-radius:9999px;background:#7CA4FF;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)"; b.radioOuter.appendChild(d); } }
      else { b.radioOuter.style.borderColor="#ddd"; var ex=b.radioOuter.querySelector(".pg-dot"); if(ex) ex.remove(); }
    }
  }

  function render(){
    var root = window.__sumRoot || document;
    var b = bundles[sel], qty = b.qty;
    var subtotal = b.sales*qty, marketTotal = b.market*qty, total = subtotal;
    setText(root.querySelector(".productList .flex-1 > div p"), b.name);
    var qs = root.querySelector(".productList .flex-1 span"); if(qs) qs.textContent = "X " + qty;
    var pw = root.querySelector(".productList .flex-1 .flex.items-center"); if(pw){ var ps=pw.querySelectorAll("p"); if(ps[0]) ps[0].textContent=money(marketTotal); if(ps[1]) ps[1].textContent=money(subtotal); }
    var li = root.querySelector(".productList img"); if(li && b.img && b.img.getAttribute("src")) li.setAttribute("src", b.img.getAttribute("src"));
    setAllRowValues(root, "Total", money(total));
    var hdr = window.__sumHeader; if(hdr){ var ht=hdr.lastElementChild; if(ht && !ht.querySelector("span")) ht.textContent=money(total); else if(ht) setLastSpan(ht, money(total)); }
  }

  // ---------- trim the page + inject VoltGuard block ----------
  function trimPage(){
    // shipping protection
    var ins=document.querySelector(".order-freight-insurance");
    if(ins){ var c=ins.closest("[token]")||ins.parentElement; (c||ins).remove(); }
    // donation widget
    var tip=document.querySelector(".order-tip"); if(tip){ (tip.parentElement && tip.parentElement.children.length===1 ? tip.parentElement : tip).remove(); }
    // Step 2 section: heading + order-payment + secure-methods block
    var op=document.querySelector(".order-payment");
    var rightbox = op ? op.closest(".rightbox") : null;
    if(!rightbox){ var s2=tightText("Step 2: Payment Methods"); rightbox = s2 ? s2.closest(".rightbox") : document.querySelector(".rightbox"); }
    if(rightbox){
      [].slice.call(rightbox.children).forEach(function(c){
        var t=c.textContent||"";
        if(/Step 2:\s*Payment Methods|Pay Confidently|CHECKOUT|Express Checkout|other payment methods/i.test(t)) c.remove();
      });
      rightbox.insertAdjacentHTML("beforeend", BLOCK_HTML());
    } else if(op){ (op.closest('[class*="mb-"]')||op).remove(); }
    // remove the grey mobile column divider between the summary and the button
    [].slice.call(document.querySelectorAll('[class*="F0F0F0"]')).forEach(function(d){
      var cls=(d.className||"").toString();
      if(/h-\[8px\]/.test(cls) && /F0F0F0/.test(cls)) d.remove();
    });
    if(rightbox){ rightbox.style.paddingTop="0"; rightbox.style.marginTop="0"; }
    wireAddToCart();
  }

  function BLOCK_HTML(){
    var pays = [["paypal","PayPal"],["visa","Visa"],["mastercard","Mastercard"],["amex","American Express"],["discover","Discover"],["applepay","Apple Pay"],["gpay","Google Pay"]]
      .map(function(p){ return '<div class="pg-pay"><img src="'+(ASSET[p[0]]||'')+'" alt="'+p[1]+'" loading="lazy"></div>'; }).join("");
    return '<div class="pg-block">' +
      '<button type="button" class="pg-atc" id="pgAtc">Add to cart</button>' +
      '<div class="pg-secure"><div class="pg-secure-lbl">SECURE PAYMENT GUARANTEED</div><div class="pg-pays">'+pays+'</div></div>' +
      '<div class="pg-guar"><img class="pg-seal" src="'+(ASSET.guarantee||'')+'" alt="90 Day Money Back Guarantee">' +
        '<div><h3>90 Day Money Back Guarantee</h3><p>Ensuring that our customers are 100% happy with every product they purchase from us is critically important to us. If you are not 100% satisfied with your purchase, you can return it for a full refund within 90 days of purchase.</p></div></div>' +
      '</div>';
  }

  function wireAddToCart(){
    var btn=document.getElementById("pgAtc"); if(!btn || btn.__pg) return; btn.__pg=true;
    btn.addEventListener("click", function(e){
      e.preventDefault();
      var b=bundles.find(function(bundle){ return bundle.card.getAttribute("data-pg-selected") === "true"; }) || bundles[sel];
      var vid=VARIANT[b.name];
      if(!vid){ alert("Checkout link not set yet. (Shopify variant ID to be added for: "+b.name+")"); return; }
      var destination = /^https?:/.test(vid) ? vid : (SHOPIFY_STORE + "/cart/" + vid + ":" + b.qty);
      destination = withTracking(destination);
      if(window.PrimeGradeFunnelAds) window.PrimeGradeFunnelAds.beginCheckout(destination);
      else window.location.href = destination;
    });
  }

  function injectCss(){
    if(document.getElementById("pg-css")) return;
    var s=document.createElement("style"); s.id="pg-css";
    s.textContent =
      ".pg-block{padding:0 15px;margin-top:0}" +
      ".pg-atc{display:block;width:100%;background:#16a34a;color:#fff;border:0;border-radius:12px;padding:17px;font-size:19px;font-weight:800;cursor:pointer;box-shadow:0 6px 16px rgba(22,163,74,.3);transition:background .15s;font-family:inherit}" +
      ".pg-atc:hover{background:#15803d}" +
      ".pg-secure{text-align:center;margin:22px 0 0}" +
      ".pg-secure-lbl{display:flex;align-items:center;gap:12px;color:#6b7280;font-size:13px;font-weight:700;letter-spacing:1px;margin-bottom:14px}" +
      ".pg-secure-lbl::before,.pg-secure-lbl::after{content:'';flex:1;height:1px;background:#e5e7eb}" +
      ".pg-pays{display:flex;flex-wrap:wrap;justify-content:center;gap:8px}" +
      ".pg-pay{width:58px;height:38px;border:1px solid #e5e7eb;border-radius:7px;display:flex;align-items:center;justify-content:center;background:#fff}" +
      ".pg-pay img{max-width:44px;max-height:26px;width:auto;height:auto}" +
      ".pg-guar{display:flex;gap:14px;align-items:flex-start;margin:26px 0 10px}" +
      ".pg-seal{flex:0 0 92px;width:92px;height:92px}" +
      ".pg-guar h3{margin:0 0 6px;font-size:18px;font-weight:800;color:#1f2937}" +
      ".pg-guar p{margin:0;font-size:14px;color:#374151;line-height:1.5}";
    document.head.appendChild(s);
  }

  // ---------- heading + footer tweaks ----------
  function renameHeading(){
    var h = tightText("Choose Your Bundles");
    var p = h ? (h.closest("p") || h) : null;
    if(!p) return;
    [].slice.call(p.querySelectorAll("svg")).forEach(function(s){ s.remove(); });
    [].slice.call(p.childNodes).forEach(function(n){ if(n.nodeType===3 && /Step\s*1:/i.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(/Step\s*1:\s*/i,""); });
  }
  function swapFooter(){
    var LOGO=ASSET.logo||"", EMAIL="support@primegradelabs.com";
    var LINKS=[
      {label:"Shipping Policy", url:"https://primegradelabs.com/policies/shipping-policy"},
      {label:"Returns & Refund", url:"https://primegradelabs.com/policies/refund-policy"},
      {label:"Privacy Policy & Cookies Policy", url:"https://primegradelabs.com/policies/privacy-policy"},
      {label:"Terms & Conditions", url:"https://primegradelabs.com/policies/terms-of-service"}
    ];
    [].slice.call(document.querySelectorAll("*")).forEach(function(e){
      var text=e.textContent||"";
      if(e.children.length===0 && (/customer@rowgins\.com/i.test(text)||/^\s*\[?email protected\]?\s*$/i.test(text))){ e.textContent=EMAIL; if(e.tagName==="A") e.setAttribute("href","mailto:"+EMAIL); }
    });
    [].slice.call(document.querySelectorAll('a[href*="customer@rowgins"],a[href*="email-protection"]')).forEach(function(a){ a.textContent=EMAIL; a.setAttribute("href","mailto:"+EMAIL); a.removeAttribute("data-cfemail"); });
    [].slice.call(document.querySelectorAll("img.footer-logo, img[class*=footer-logo]")).forEach(function(l){ l.setAttribute("src",LOGO); l.removeAttribute("srcset"); l.style.maxWidth="150px"; });
    var leaf=[].slice.call(document.querySelectorAll("div,a,span,li")).find(function(e){ return e.children.length===0 && /^(Return\s*&\s*Refund\s*Policy|Privacy\s*Policy|Terms\s*&\s*Conditions)$/i.test((e.textContent||"").trim()); });
    if(leaf){ var item=leaf.closest('[class*="cursor-pointer"]'); var row=item?item.parentElement:leaf.parentElement;
      if(row && row.getAttribute("data-pgfx")!=="1"){ var itemCls=item?(item.className||"").toString():"px-2 cursor-pointer hover:underline"; var html="";
        LINKS.forEach(function(L){ html+='<div class="'+itemCls+'"><a href="'+L.url+'" target="_blank" rel="noopener" style="color:inherit;text-decoration:none">'+L.label+'</a></div>'; });
        row.innerHTML=html; row.setAttribute("data-pgfx","1"); } }
  }

  // ---------- small helpers ----------
  function txt(el){ return el ? (el.textContent||"").trim() : ""; }
  function marketText(el){ if(!el) return ""; var c=el.cloneNode(true); [].slice.call(c.querySelectorAll("span")).forEach(function(s){ if(/slash/i.test(s.className)) s.remove(); }); return c.textContent; }
  function setText(el,v){ if(el) el.textContent=v; }
  function setLastSpan(row,v){ if(!row) return; var sp=row.querySelectorAll("span"); if(sp.length) sp[sp.length-1].textContent=v; }
  function setAllRowValues(root,label,v){ [].slice.call(root.querySelectorAll("div")).forEach(function(d){ var ch=d.children; if(ch.length===2 && ch[0].tagName==="SPAN" && ch[1].tagName==="SPAN" && ch[0].textContent.trim()===label) ch[1].textContent=v; }); }
  function removeRowsByLabel(root,label){ [].slice.call(root.querySelectorAll("div")).forEach(function(d){ var ch=d.children; if(ch.length===2 && ch[0].tagName==="SPAN" && ch[1].tagName==="SPAN" && ch[0].textContent.trim()===label) d.remove(); }); }
  function withTracking(url){
    var allowed=/^(gclid|gbraid|wbraid|fbclid|msclkid|utm_[a-z0-9_]+)$/i;
    var current=new URLSearchParams(window.location.search), target=new URL(url,window.location.origin);
    current.forEach(function(value,key){
      if(!allowed.test(key)) return;
      target.searchParams.set(key,value);
      target.searchParams.set("attributes["+key+"]",value);
    });
    return target.toString();
  }
  function collapsible(header, body){
    if(!header||!body||header.__pg) return; header.__pg=true; header.style.cursor="pointer";
    var startCollapsed=/grid-rows-\[0fr\]/.test(body.className)||body.style.gridTemplateRows==="0fr"||body.style.gridTemplateRows==="";
    body.style.display="grid"; body.style.gridTemplateRows=startCollapsed?"0fr":"1fr"; body.style.opacity=startCollapsed?"0":"1";
    header.addEventListener("click", function(e){ if(e.target.closest("input,button,a")) return; var open=body.style.gridTemplateRows==="1fr"; body.style.gridTemplateRows=open?"0fr":"1fr"; body.style.opacity=open?"0":"1"; });
  }
})();
